makeRequest();

function findAndLogOptionVariant() {

  // Find the input element with the name attribute set to 'id'
  const inputElement = document.querySelector('input[name="id"]');

  // Check if the inputElement exists
  if (inputElement) {
    // Get the value of the inputElement
    const inputValue = inputElement.value;

    // Find the option element with the data-variant attribute matching the inputValue
    const optionElement = document.querySelector(`option[data-variant="${inputValue}"]`);

    // Check if the optionElement exists
    if (optionElement) {
      
    var addToCartButtonData = document.querySelectorAll('[id*="addtocartbutton"], [id*="buyitnowbutton"]');
    var stockout = document.querySelectorAll('.stockout');

      // Check the value of the optionElement and log the result
      if (optionElement.value === 'no') {
        addToCartButtonData.forEach(function (button) {
        stockout.forEach(function (element) {
          element.style.display = 'block';
        });
        console.log('no')
        button.setAttribute('stock', 'no');
        button.setAttribute('disabled', 'disabled');
        button.classList.add("greyedout"); // Add the class
        });
      } else {
        addToCartButtonData.forEach(function (button) {
        stockout.forEach(function (element) {
          element.style.display = 'none';
        });
        button.removeAttribute('stock');
        if (!(button.getAttribute('data-fill') === 'no' || button.getAttribute('stock') === 'no')) {
        button.removeAttribute('disabled');
        button.classList.remove("greyedout"); // Add the class 
        }
        console.log('yes');
        });
      }
    } else {
    var addToCartButtonData = document.querySelectorAll('[id*="addtocartbutton"]');
    var stockout = document.querySelectorAll('.stockout');
        addToCartButtonData.forEach(function (button) {
        stockout.forEach(function (element) {
          element.style.display = 'none';
        });
        button.removeAttribute('stock');
        if (!(button.getAttribute('data-fill') === 'no' || button.getAttribute('stock') === 'no')) {
        button.removeAttribute('disabled');
        button.classList.remove("greyedout"); // Add the class 
        }
        console.log('yes');
        });
    }
  } else {
    console.log('Input element with name "id" not found');
  }
}


/////////////////////////////////////////////////////////////

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

onSubmitHandler(evt) {
  evt.preventDefault();

  const submitButton = evt.submitter || this.querySelector('[type="submit"]'); // <-- Use evt.submitter to detect the button clicked
  if (submitButton.classList.contains('loading')) return;

  this.handleErrorMessage();

  submitButton.setAttribute('aria-disabled', true);
  submitButton.classList.add('loading');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
  formData.append('sections_url', window.location.pathname);
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }

      if (submitButton.dataset.buyitnow === "true") {
        // If this is the Buy It Now button, go straight to checkout
        window.location.href = '/checkout';
      } else {
        // Otherwise behave normally
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.cartNotification.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      makeRequest();
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
    });
}


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}